import React, { ReactNode } from 'react';

// Many components use a StatusMessage state
export interface StatusMessageType {
  type: MessageType;
  message: string;
}
export type MessageType = 
  'success' |
  'warning' |
  'error' |
  'info';
type MessageTheme = 'dark' | 'light';
const Message = ({
  children,
  theme = 'dark',
  type,
}: {
  children?: ReactNode;
  theme?: MessageTheme;
  type: MessageType;
}): JSX.Element => {
  let messageStyle;
  switch (type) {
    case 'error':
      messageStyle = {
        background: 'rgba(255,0,0,0.25)',
        borderColor: 'rgb(255,0,0)',
      };
      break;
    case 'info':
      messageStyle = {
        background: 'rgba(0,155,255,0.25)',
        borderColor: 'rgb(0,155,255)',
      };
      break;
    case 'warning':
      messageStyle = {
        background: 'rgba(255,255,0,0.125)',
        borderColor: 'rgb(255,255,0)',
      };
      break;
    case 'success':
      messageStyle = {
        background: 'rgba(0,255,0,0.125)',
        borderColor: 'rgb(0,255,0)',
      };
      break;
    default:
      messageStyle = {
        background: 'rgba(255,0,0,0.25)',
        borderColor: 'red',
      };
      break;
  }
  
  return (
    <div
      className="br-1 f-small mb-4 outline pa-3"
      style={{
        boxShadow: (theme === 'dark') ? '0 0 5px black' : '0 1px 5px #bbb',
        color: (theme === 'dark') ? 'white' : 'black',
        ...messageStyle
    }}>
      {children}
    </div>
  );
};

export default Message;
